module.exports = "pegasus_template/assets/arrow-right.png";